import { render } from "./FAQItem.vue?vue&type=template&id=7d6fe77d"
import script from "./FAQItem.vue?vue&type=script&lang=js"
export * from "./FAQItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__